// 要素を表示する関数
const slideDown = function (el) {
  el.style.height = "auto"; //いったんautoに
  let h = el.offsetHeight; //autoにした要素から高さを取得
  el.animate(
    {
      // 高さ0から取得した高さまでのアニメーション
      height: [0, h + "px"],
    },
    {
      duration: 300, // アニメーションの時間
    }
  );
  el.style.height = "auto"; //ブラウザの表示幅を途中で閲覧者が変えた時を考慮してautoに戻す
};
// 要素を非表示にする関数
const slideUp = function (el) {
  let h = el.offsetHeight;
  el.style.height = h + "px";
  el.animate(
    {
      height: [h + "px", 0],
    },
    {
      duration: 300,
    }
  );
  el.style.height = 0;
};
//アコーディオンコンテナ全てで実行
const accordions = document.querySelectorAll(".include-accordion");
accordions.forEach(function (accordion) {
  //アコーディオンボタン全てで実行
  const accordionBtns = accordion.querySelectorAll(".p-faq-question");
  accordionBtns.forEach(function (accordionBtn, index) {
    accordionBtn.addEventListener("click", function (e) {
      e.currentTarget.parentNode.classList.toggle("active"); //ボタンの親要素にクラスを付与／削除
      const content = e.currentTarget.nextElementSibling; //ボタンの次の要素を取得
      if (e.currentTarget.parentNode.classList.contains("active")) {
        slideDown(content); //クラス名がactive（＝閉じていた）なら上記で定義した開く関数を実行
      } else {
        slideUp(content); //クラス名にactiveがない（＝開いていた）なら上記で定義した閉じる関数を実行
      }
    });
  });
});
